module.exports = __webpack_public_path__ + "img/20200106160403360截图20200106111001043.a0c6f488.jpg";